import { Component, OnInit, Inject, ElementRef, ViewChild, AfterContentInit, DoCheck, AfterViewInit, AfterViewChecked, AfterContentChecked } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { User, Role, Module } from '../../../pages/users/user.model';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../shared/services/auth.service';
import { SettingsService } from '../../../pages/settings/settings.service';
import { UsersService } from '../../../pages/users/users.service';

@Component({
  selector: 'app-permission-dialog',
  templateUrl: './permission-dialog.component.html',
  styleUrls: ['./permission-dialog.component.scss'],
  providers: [ UsersService, SettingsService ]
})
export class PermissionDialogComponent implements OnInit, AfterContentInit, DoCheck, AfterViewInit, AfterViewChecked, AfterContentChecked {
  public form: FormGroup;
  public passwordHide: boolean = true;
  public roles: Role[];
  public modules: Module[];
  public modulesUser: Array<number>;
  public modulesEdit: Array<number>;
  public modulesDelete: Array<number>;
  public modulesUserDefault: Array<number>;
  public modulesEditDefault: Array<number>;
  public modulesDeleteDefault: Array<number>;
  public user: User;
  public roleId: number;
  public selVal = new Role();
  @ViewChild('list') list: ElementRef;
  public toppings = new FormControl();

  constructor(
            public usersService: UsersService,
            public settingsService: SettingsService,
            public dialogRef: MatDialogRef<PermissionDialogComponent>,
            @Inject(MAT_DIALOG_DATA) public data: any,
            public fb: FormBuilder,
            private toastr: ToastrService
        ) {

    this.user = data.user;
    this.roleId = data.roleId;
    this.modules = data.modules;
    this.modulesUser = data.modulesUser;
    this.modulesEdit = data.modulesEdit;
    this.modulesDelete = data.modulesDelete;

    this.form = this.fb.group({
      permissions: null,
    });

    console.log('CONSTRUCTOR_USER_DIALOG');
  }

  onClickModuleEdit(list, listEdit) {
    listEdit.selectedOptions.selected.map(x => {
      list.options.map(x1 => {
        if (x1.value === x.value) {
          x1.selected = true;
        }
      });
    });
  }

  onClickModuleDelete(list, listDelete) {
    listDelete.selectedOptions.selected.map(x => {
      list.options.map(x1 => {
        if (x1.value === x.value) {
          x1.selected = true;
        }
      });
    });
  }

  onSelectPermission(list, listEdit, listDelete) {
    console.log(list);

    list.options.map(per => {
      if (!per.selected) {
        listEdit.options.map(x => {
          if (x.value === per.value && x.selected) {
            x.selected = false;
            x.disabled = true;
          }
        });

        listDelete.options.map(x => {
          if (x.value === per.value && x.selected) {
            x.selected = false;
            x.disabled = true;
          }
        });
      } else {
        listEdit.options.map(x => {
          if (x.value === per.value) {
            x.disabled = false;
          }
        });

        listDelete.options.map(x => {
          if (x.value === per.value) {
            x.disabled = false;
          }
        });
      }
    });

  }

  ngOnInit() {
    if (this.user) {
      this.roleId = this.user.role.id;
      this.form.setValue(this.user);
    } else {
      this.user = new User();

      this.settingsService.getModulesByRole(this.roleId).subscribe(modules => {
        this.modulesUserDefault = modules;
        this.modulesUser = this.modulesUser ? this.modulesUser.concat(modules) : modules;

        this.modules.map(x => {
          if(x.id == modules.find(y => y == x.id)) {
            //x.disabled = true;
          }
        });
      });

      this.settingsService.getModulesEditByRole(this.roleId).subscribe(modules => {
        this.modulesEditDefault = modules;
        this.modulesEdit = this.modulesEdit ? this.modulesEdit.concat(modules) : modules;

        this.modules.map(x => {
          if(x.id == modules.find(y => y == x.id)) {
            //x.disabled = true;
          }
        });
      });

      this.settingsService.getModulesDeleteByRole(this.roleId).subscribe(modules => {
        this.modulesDeleteDefault = modules;
        this.modulesDelete = this.modulesDelete ? this.modulesDelete.concat(modules) : modules;

        this.modules.map(x => {
          if(x.id == modules.find(y => y == x.id)) {
            //.disabled = true;
          }
        });
      });
    }

    console.log(this.user);
    console.log(this.modulesUser);
    console.log(this.modulesEdit);
    console.log(this.modulesDelete);
  }

  ngAfterContentInit() {
  }

  ngDoCheck() {
  }

  ngAfterViewChecked() {
  }

  ngAfterContentChecked() {
    
  }

  ngAfterViewInit() {
  }

  asd() {
    debugger
  }

  save(user: User): void {
    console.log(user);

    if (user) {
      if (!user.id) {
        this.usersService.userExist(user.username).subscribe(exist => {
          if (exist) {
            this.toastr.error('', 'El usuario ya existe');
          } else {
            this.dialogRef.close(user);
          }
        });
      } else {
        this.dialogRef.close(user);
      }
    }

  }

  close(): void {
    const data = {
      modulesUser: this.modulesUser.filter(x => {
        return x != this.modulesUserDefault.find(y => y == x);
      }),
      modulesEdit: this.modulesEdit.filter(x => {
        return x != this.modulesEditDefault.find(y => y == x);
      }),
      modulesDelete: this.modulesDelete.filter(x => {
        return x != this.modulesDeleteDefault.find(y => y == x);
      }),
    };

    this.dialogRef.close(data);
  }

  getNameTypeInsurance = (id) => {
    for (const key in this.modules) {
      if (this.modules.hasOwnProperty(key)) {
        const element = this.modules[key];
 
        if (element.id === id) {
         return element.name;
       }
      }
    }
 
   }

}
